export default "__VITE_ASSET__11f26c64__"